export const FORM_REQUIRED_FIELD_ERROR = "This field is required.";

export const GENERIC_TOAST_ERROR_MESSAGE = "Something went wrong...";

export const GENERIC_TOAST_SAVED_MESSAGE = "Saved!";

export const GENERIC_TOAST_DELETED_MESSAGE = "Deleted!";
